function isValidListener(listener) {
    if (typeof listener === 'function') {
        return true;
    }
    return false;
}
function getIndexOfListeners(list, item) {
    let result = -1;
    for (let i = 0; i < list.length; i += 1) {
        if (list[i] === item) {
            result = i;
            break;
        }
    }
    return result;
}
class EventEmitter {
    constructor() {
        this.internalEventMap = new Map();
    }
    on(event, listener) {
        if (!event || !listener)
            return;
        if (typeof event !== 'string') {
            console.error(`Event name listener must be string, but got ${typeof event}!`);
            return;
        }
        if (!isValidListener(listener)) {
            console.error(`Event "${event}" listener must be a function!`);
            return;
        }
        const eventMap = this.internalEventMap;
        let listeners = [];
        if (eventMap.has(event) && Array.isArray(eventMap.get(event)?.listeners)) {
            listeners = eventMap.get(event)?.listeners;
        }
        else {
            eventMap.set(event, { listeners });
        }
        if (getIndexOfListeners(listeners, listener) === -1) {
            listeners.push(listener);
        }
    }
    off(event, listener) {
        if (typeof event !== 'string') {
            return;
        }
        const eventMap = this.internalEventMap;
        if (!eventMap.has(event)) {
            return;
        }
        const listeners = eventMap.get(event)?.listeners;
        if (!Array.isArray(listeners)) {
            return;
        }
        let index;
        for (let i = 0, len = listeners.length; i < len; i += 1) {
            if (listeners[i] && listeners[i] === listener) {
                index = i;
                break;
            }
        }
        if (typeof index !== 'undefined') {
            listeners.splice(index, 1);
        }
    }
    emit(event, ...args) {
        if (typeof event !== 'string') {
            return;
        }
        const eventMap = this.internalEventMap;
        if (!eventMap.has(event)) {
            return;
        }
        const listeners = eventMap.get(event)?.listeners;
        if (!Array.isArray(listeners)) {
            return;
        }
        listeners.forEach((listener) => {
            if (isValidListener(listener)) {
                listener.apply(this, args || []);
            }
        });
    }
}
export { EventEmitter };
